function mapEtatFiche(etatFiche) {
    switch (etatFiche) {
      case "0":
        return "Nouveau";
      case "1":
        return "En cours";
      case "2":
        return "Traité";
      case "3":
        return "Abandonné";
      case "4":
        return "Répondeur";
      default:
        return etatFiche;
    }
  }
export default mapEtatFiche;